module.exports = __webpack_public_path__ + "img/JunNishimura_企画書_ページ_04.90f57fa2.jpg";